module.exports = __webpack_public_path__ + "static/media/cert_4995.c8097b8c.jpg";